import React from "react";
import PropTypes from "prop-types";

import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "material-ui/Table";
import { dollarValue } from "./helpers/presentation";

const OvAccountsInfoTable = props => {
  const { data } = props;

  const renderTableRows = () => {
    return data.map((d, i) => {
      return (
        <TableRow key={i}>
          <TableCell>{d.name.split("|")[1]}</TableCell>
          <TableCell numeric>{dollarValue(d.license_cost)}</TableCell>
          <TableCell numeric>{dollarValue(d.instance_cost)}</TableCell>
          <TableCell numeric>{dollarValue(d.storage_cost)}</TableCell>
          <TableCell numeric>{d.cores.toFixed(3)}</TableCell>
          <TableCell numeric>{d.minutes.toFixed(2)}</TableCell>
          <TableCell numeric>{d.storage.toFixed(2)}</TableCell>
        </TableRow>
      );
    });
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Account</TableCell>
          <TableCell numeric>License cost</TableCell>
          <TableCell numeric>Instance cost</TableCell>
          <TableCell numeric>Storage cost</TableCell>
          <TableCell numeric>Cores</TableCell>
          <TableCell numeric>Minutes</TableCell>
          <TableCell numeric>Storage</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>{renderTableRows()}</TableBody>
    </Table>
  );
};

OvAccountsInfoTable.propTypes = {
  data: PropTypes.array.isRequired
};

export default OvAccountsInfoTable;



// WEBPACK FOOTER //
// ./src/OvAccountsInfoTable.js